import {
  STORE_FIND_OR_CREATE_REQUESTED,
  STORE_FIND_OR_CREATE_SUCCESS,
  STORE_FIND_OR_CREATE_FAILURE,
  INSTALL_REQUESTED,
  INSTALL_SUCCESS,
  INSTALL_FAILURE,
} from '../types';

const INITIAL_STATE = {
  store: null,
  storeAdmin: null,
  storeUsers: [],
  activeSubscriptions: [],
  installed: false,
  settings: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const stores = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case INSTALL_REQUESTED:
      return Object.assign({}, state, {
        installed: false
      });

    case INSTALL_SUCCESS:
      return Object.assign({}, state, {
        installed: true
      });

    case INSTALL_FAILURE:
      return Object.assign({}, state, {
        installed: false
      });

    case STORE_FIND_OR_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      });

    case STORE_FIND_OR_CREATE_SUCCESS:
      return Object.assign({}, state, {
        store: action.payload.store,
        storeAdmin: action.payload.store_admin,
        storeUsers: action.payload.store_users || [],
        activeSubscriptions: action.payload.subscriptions || [],
        settings: action.payload.settings,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case STORE_FIND_OR_CREATE_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    default:
      return state;
  }
}

export default stores;
